import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';

import { IDecisionListFilterState } from '../interfaces/IDecisionListFilterState';
import { DecisionListFilterAction } from '../types/DecisionListFilterAction';
import { DecisionListFilterActionsEnum } from '../enums/DecisionListFilterActionsEnum';
import { IDecisionListFilterWithMeta } from '../interfaces/IDecisionListFilterWithMeta';

const initialState: IDecisionListFilterState = {
  current: getStorageItem(StorageNamesEnum.DECISION_FILTER),
  isFilterOn: !!getStorageItem(StorageNamesEnum.DECISION_FILTER_ON),
  filters: [],
  currentControlOrganizations: [],
  currentSupervisionTypes: [],
};

export function decisionListFilterReducer(state = initialState, action: DecisionListFilterAction) {
  switch (action.type) {
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT: {
      const { current, currentId } = action.payload;
      const newState: IDecisionListFilterState = {
        ...state,
        current,
        currentId,
      };

      setStorageItem(StorageNamesEnum.DECISION_FILTER, current);

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_SWITCHER: {
      const { value: isFilterOn } = action.payload;
      const newState: IDecisionListFilterState = {
        ...state,
        isFilterOn,
      };

      setStorageItem(StorageNamesEnum.DECISION_FILTER_ON, isFilterOn);

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_META: {
      const filters = action.payload.list.map<IDecisionListFilterWithMeta>(meta => ({ meta }));
      const newState: IDecisionListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_REMOVE: {
      const { id } = action.payload;
      const filters = state.filters.filter(f => f.meta.id !== id);
      const newState: IDecisionListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_DATA: {
      const { id, data } = action.payload;
      const filters = state.filters.map<IDecisionListFilterWithMeta>(filter => {
        if (filter.meta.id === id) {
          return {
            ...filter,
            data,
            meta: {
              ...filter.meta,
              id,
              name: data.name,
            },
          };
        }

        return filter;
      });
      const newState: IDecisionListFilterState = {
        ...state,
        filters,
      };

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS: {
      const { ids } = action.payload;
      const newState: IDecisionListFilterState = {
        ...state,
        currentControlOrganizations: ids,
      };

      return newState;
    }
    case DecisionListFilterActionsEnum.DECISION_LIST_FILTER_SET_CURRENT_SUPERVISION_TYPES: {
      const { ids } = action.payload;
      const newState: IDecisionListFilterState = {
        ...state,
        currentSupervisionTypes: ids,
      };

      return newState;
    }
    default:
      return state;
  }
}
